import { combineReducers } from "redux";

import payment from "./payment";
import cart from "./cart";
import account from "./account";
import paymentPlan from "./paymentPlan";

const rootReducer = combineReducers({
  payment,
  cartReducer: cart,
  accountReducer: account,
  paymentPlanReducer: paymentPlan,
});

export default rootReducer;
